import React from 'react'
import { SelectionPhasesContainer } from '@/components/containers/selection-phases'
import { useTitle } from '@/hooks/use-title'
import SettingsIcon from '@material-ui/icons/Settings'

export const SelectionPhasesPage: React.FC = () => {
  useTitle('設定 / 選考フェーズ', <SettingsIcon />)
  return <SelectionPhasesContainer />
}
